import { render, staticRenderFns } from "./acceptingOrder.vue?vue&type=template&id=4701c306&"
import script from "./acceptingOrder.vue?vue&type=script&lang=js&"
export * from "./acceptingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports